import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { AdminStatusSwitchIcon } from '@/epics/adminManagment/pages/adminList/AdminStatusDialogContent';

export type FacilityStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getFacilityStatusDialogConfig(
  facilityName: string,
  isActive: boolean
): FacilityStatusDialogConfig {
  const isActivating = !isActive;
  return {
    title: isActivating ? 'Aktywować placówkę?' : 'Dezaktywować placówkę?',
    content: (
      <>
        <span>
          {isActivating
            ? 'Czy na pewno chcesz aktywować placówkę '
            : 'Czy na pewno chcesz dezaktywować placówkę '}
        </span>
        <span className="font-medium">{facilityName}</span>
        <span>?</span>
      </>
    ),
    confirmButtonLabel: isActivating ? 'Aktywuj' : 'Dezaktywuj',
    confirmButtonLabelLoading: isActivating
      ? 'Aktywowanie…'
      : 'Dezaktywowanie…',
    icon: <AdminStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
